import React, { Component } from "react";
import theme from "styles/theme";
import { themeOptions } from "styles/theme";
import Body from "../item/body";
import MoreColors from "../item/more-colors";
import Banner from "../item/banner";
import ColorBanner from "../item/color-banner";
import Image from "../item/image";
import InlineNotes from "../item/inline-notes";
import NotesIcon from "components/icons/notes";
import { format } from "lib/globalize-util";
import classNames from "classnames";
import { merge, $, media, presets } from "glamor";
import { ItemCellSize } from "constants/types";
import ViewBase from "./base";
import { displayingNewColorways } from "helpers/swatch-utils";
import { DATATEST } from "constants/integration";

const ITEM_HEIGHT = 510;
export const ITEM_WIDTH = 189;
export const HORIZONTAL_OFFSET = 8;

class ItemCard extends Component {
    static height = ITEM_HEIGHT;
    static width = ITEM_WIDTH;
    static horizontalOffset = HORIZONTAL_OFFSET;
    static verticalOffset = 12;

    static styles = merge(
        {
            width: `${ITEM_WIDTH}px`,
            height: `${ITEM_HEIGHT}px`,
        },
        $(" .item", {
            height: `${ITEM_HEIGHT - 13}px`,
            width: `${ITEM_WIDTH}px`,
            padding: "8px",
        }),
        $(" .imageHolder", {
            position: "relative",
            overflow: "hidden",
            height: "272px",
            width: `${ITEM_WIDTH - 16}px`,
            marginBottom: "8px",
            display: "flex",
            alignItems: "center",
        }),
        $(" .imageHolderMobileHeight", {
            height: "310px",
        }),
        $(" .imageOverlay", {
            position: "absolute",
            top: 0,
            width: "100%",
            height: "100%",
        }),
        $(" .quickview", {
            position: "absolute",
            bottom: "58px",
            left: "0px",
            right: "0px",
            zIndex: 3,
            display: "block",
            margin: "0px auto",
            width: "100px",
            height: "24px",
            borderRadius: "12px",
            backgroundColor: "white",
            textAlign: "center",
            border: `solid 1px ${themeOptions.palette.grey}`,
            fontSize: "12px",
            color: themeOptions.palette.darkGrey,
            transition: "all .2s ease-in-out",
            opacity: 0,
        }),
        $(" .quickview.quickviewHover", {
            bottom: "58px",
            opacity: 1,
        }),
        $(" .disabledBanner", {
            position: "absolute",
            top: "50%",
            left: "0px",
            right: "0px",
            zIndex: 4,
            backgroundColor: "rgba(45, 45, 45, .8)",
            lineHeight: "50px",
            transform: "translateY(-50%)",
            color: "white",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "normal",
        }),
        $(" .moreColorLabel", {
            top: "404px",
            left: "8px",
        }),
        $(" .swatches", {
            bottom: "0px",
            left: "8px",
            right: "8px",
        }),
        $(" .swatches.showAllSwatches", {
            top: "0px",
        }),
        $(" .swatches.colorChipsEnabledCollapsed", {
            height: "50px !important",
        }),
        $(" .swatches.colorChipsEnabledOpen", {
            height: "177px !important",
            position: "absolute",
            bottom: "0px !important",
            backgroundColor: "rgba(255,255,255,.95)",
        }),
        $(" .unavailableProduct", {
            position: "absolute",
            width: `${ITEM_WIDTH - 16}px`,
            backgroundColor: themeOptions.palette.errorBackgroundColor,
            color: themeOptions.palette.errorColor,
            height: "150px",
            top: "20%",
            padding: "16px",
            fontSize: "14px",
            left: "8px",
        }),
        $(" .unavailable", {
            opacity: "0.3",
        }),
        media(presets.phablet, {
            width: `${ITEM_WIDTH}px`,
        })
    );

    render() {
        const {
            actions,
            item,
            editable,
            catalogEntry,
            view,
            viewNotes,
            isDragging,
            scope,
            hideMsrp,
            hideWholesale,
            isGrapesJs,
        } = this.props;
        const { showImageOverlay } = this.props;
        const { onUpdate, onMoreInfo, onViewNotes, onToggleViewMore } = actions;
        const { hover, inOrder, inActiveList } = this.state;
        const swapOnHover = scope.brand.hasPreference("swap_product_image_on_hover");

        const colorChipsEnabled = displayingNewColorways(scope.brand);

        let notes = null;
        const isMobileViewport = window.matchMedia("(max-width: 750px)");

        if (
            catalogEntry &&
            (catalogEntry.notes || (editable && hover)) &&
            !viewNotes &&
            onViewNotes &&
            !colorChipsEnabled
        ) {
            notes = (
                <NotesIcon
                    style={{
                        position: "absolute",
                        right: "8px",
                        top: "450px",
                        width: "18px",
                        height: "22px",
                        cursor: "pointer",
                    }}
                    onClick={this.handleNotesIconClick}
                    data-test={DATATEST.CATALOG.PANEL_ADD_NOTES_BTN}
                />
            );
        }

        let upperElements;

        if (!viewNotes) {
            upperElements = [
                <ColorBanner
                    key="colorBanner"
                    item={item}
                    hover={hover}
                    inOrder={inOrder}
                    inActiveList={inActiveList}
                />,
                <Banner key="banner" item={item} scope={scope} />,
                item && item.hasCustomizationBanner(scope) && (
                    <Banner key="customization" item={item} banner={item.getCustomizationBanner(scope)} scope={scope} />
                ),
                this.renderActions(3, false),
            ].filter(Boolean);

            if (onMoreInfo) {
                upperElements.push(
                    <button
                        key="viewDetails"
                        onClick={this.handleItemMoreInfo}
                        className={classNames("quickview", {
                            quickviewHover: hover,
                        })}
                    >
                        {format("View Detail")}
                    </button>
                );
            }

            if (item) {
                if (!item.isAvailable(scope)) {
                    upperElements.push(
                        <div key="disabledBanner" className="disabledBanner">
                            {format("Inactive")}
                        </div>
                    );
                } else if (item._disabled && !scope.brand.hasPreference("hide_currency_warning")) {
                    upperElements.push(
                        <div key="disabledBanner" className="disabledBanner">
                            {format("Not available for |code|", { code: scope.currencyCode })}
                        </div>
                    );
                }
            }
        }

        return (
            <article>
                {this.renderBulkSelector()}
                {this.productActionMenu()}
                {viewNotes && catalogEntry && (
                    <InlineNotes
                        key="inlineNotes"
                        catalogEntry={catalogEntry}
                        editable={!isDragging && editable}
                        onRequestClose={this.handleNotesDialogClose}
                        onUpdate={onUpdate}
                    />
                )}
                <div
                    className={`imageHolder ${isMobileViewport.matches ? "imageHolderMobileHeight" : ""} ${
                        item && item.__out_of_range ? "unavailable" : ""
                    }`}
                >
                    {item && view && <Image swapOnHover={swapOnHover} item={item} scope={scope} size={"G"} />}
                    {showImageOverlay && <div className="imageOverlay" />}
                    {item && view && upperElements}
                </div>
                <div className={`textContent ${item && item.__out_of_range ? "unavailable" : ""}`}>
                    <Body
                        item={item}
                        shipStart={this.getShipStart()}
                        view={view}
                        size={ItemCellSize.Big}
                        scope={scope}
                        showPrice={!hideWholesale}
                        hideMSRP={hideMsrp}
                    />
                    {notes}
                    {item && !item.__product_customizations_template_id && (
                        <MoreColors
                            item={item}
                            scope={scope}
                            onSwatchSelected={this.handleSwatchSelected}
                            alwaysTruncateColors={true}
                            onToggleViewMore={onToggleViewMore}
                            isGrapesJs={isGrapesJs}
                        />
                    )}
                </div>
                {item && item.__out_of_range && catalogEntry && (
                    <div className="unavailableProduct">{catalogEntry.unavailableProductWarning(scope)}</div>
                )}
            </article>
        );
    }
}

export const ProductCard = ItemCard;
export default ViewBase(ItemCard);
